<template>
  <div class="battery-soc">
    <div class="soc-text">{{ soc ?? '--' }}</div>
    <div class="battery-container">
      <!-- <img class="soc-flash" src="@/assets/images/flash.png" width="8"></img> -->
      <!-- <div class="soc-percentage" :style="{ width: soc + '%' }"></div> -->

      <div class="soc-block" :class="{'select': isSelect(i)}" v-for="i in 6" :key="i"></div>
    </div>
    <div class="battery-positive"></div>
  </div>
</template>




<script setup>
import { ref } from 'vue'


const props = defineProps({
  soc: {
    type: Number,
    default: 0
  }
})


function isSelect(i) {
  return i <= props.soc * 6 / 100;
}


</script>




<style scoped lang="scss">
.battery-soc {
  display: flex;
  
  // border: 1px solid blue;
  align-items: center;
}

.battery-container {
  // width: 60px;
  // height: 30px;  
  border: 2px solid #83D8A7;
  border-radius: 3px;
  background: #fff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2px;
  padding: 2px;
}

.battery-positive {
  width: 3px;
  height: 8px;
  border-radius: 3px;
  background: #83D8A7;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.soc-flash {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 8px;
}

.soc-text {
  // position: absolute;
  color: #000000;

  margin-right: 8px;
  width: 40px;
  text-align: right;
  font-size: 12px;
  font-weight: 600;
  // color: #37B24F;
  text-shadow:
    1px 0 0 #fff,
    0 1px 0 #fff,
    -1px 0 0 #fff,
    0 -1px 0 #fff;
}

.soc-percentage {
  background: linear-gradient(264.39deg, #75ED8C 2.74%, #37B24F 96.89%);
  border-radius: 3px;
  height: 100%;
  width: 0;
}

.soc-block {
  width: 3px;
  height: 10px;
  background-color: #afeeca;
  border-radius: 2px;
}

.soc-block.select {
  background-color: #26AE52;
}
</style>
